import { createStudyModule } from '@izimi/modules';

import { studyApi } from '../di';

export const studyModule = createStudyModule({ studyApi });
